import React from 'react';
import { FeaturesSection } from '../components/FeaturesSection';
import { CTASection } from '../components/CTASection';
export const FeaturesPage = () => {
  return <div data-id="element-234">
      {/* Hero Section with Image */}
      <div className="relative bg-gradient-to-br from-blue-50 to-white py-16 md:py-20" data-id="element-235">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-236">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-237">
            {/* Text Content */}
            <div className="w-full lg:w-1/2 text-center lg:text-left" data-id="element-238">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-239">
                Powerful Features for Sales Hiring
              </h1>
              <p className="text-xl text-gray-600 mb-8" data-id="element-240">
                Everything you need to find, assess, and hire top sales talent
                efficiently. Built specifically for high-volume recruiting
                teams.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-241">
                <a href="#features" className="px-6 py-3 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors text-center" data-id="element-242">
                  Explore Features
                </a>
                <a href="/contact" className="px-6 py-3 bg-white text-blue-600 font-medium rounded-md border border-blue-200 hover:border-blue-300 transition-colors text-center" data-id="element-243">
                  Request Demo
                </a>
              </div>
            </div>

            {/* Hero Image */}
            <div className="w-full lg:w-1/2" data-id="element-244">
              <div className="relative" data-id="element-245">
                <div className="absolute inset-0 bg-blue-200 rounded-lg transform translate-x-3 translate-y-3" data-id="element-246"></div>
                <div className="relative bg-white p-4 rounded-lg shadow-xl" data-id="element-247">
                  <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Sales team collaborating on hiring decisions" className="w-full h-auto rounded-md" data-id="element-248" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div id="features" data-id="element-249">
        <FeaturesSection data-id="element-250" />
      </div>

      <CTASection data-id="element-251" />
    </div>;
};